import { render, staticRenderFns } from "./MyBrowse.vue?vue&type=template&id=573fa480&scoped=true"
import script from "./MyBrowse.vue?vue&type=script&lang=js"
export * from "./MyBrowse.vue?vue&type=script&lang=js"
import style0 from "./MyBrowse.vue?vue&type=style&index=0&id=573fa480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573fa480",
  null
  
)

export default component.exports